import React, { ChangeEvent, useState } from "react";

import { useProfile } from "@/customHooks/useProfile";
import { useTranslation } from "next-i18next";
import { Folder } from "~types/folder";

import { SwipeableEdgeDrawer } from "@/components/elements/bottom-drawer-with-edge/BottomDrawerWithEdge";
import { MemoizedTextField } from "@/components/elements/memoized-textfield/MemoizedTextField";
import { Button, CircularProgress, Container, useTheme } from "@mui/material";

interface FolderEditDrawerProps {
  isOpen: boolean;
  toggleDrawer: any;
  closeFolderDrawer: any;
  closeMoreDrawer: any;
  folder: Folder;
}

export const FolderEditDrawer = ({
  isOpen,
  toggleDrawer,
  closeFolderDrawer,
  closeMoreDrawer,
  folder
}: FolderEditDrawerProps): JSX.Element => {
  const { editFolder } = useProfile();
  const { t } = useTranslation("searchpage");
  const theme = useTheme();

  const [folderName, setFolderName] = useState<string>(folder.name);

  const handleChangeFolderName = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setFolderName(e.target.value);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      await editFolder.mutateAsync({
        folderId: folder.pk,
        newFolderName: folderName
      });
      closeMoreDrawer();
      closeFolderDrawer();
      setFolderName("");
    } catch (e) {
      console.log("Can't edit folder");
    }
  };

  return (
    <SwipeableEdgeDrawer
      isOpen={isOpen}
      toggleDrawer={toggleDrawer}
      disableGutters>
      <Container sx={{ mb: 4 }}>
        <form action="create-folder" onSubmit={handleSubmit}>
          <MemoizedTextField
            value={folderName}
            onChange={handleChangeFolderName}
            fullWidth
            label={t("favourites.edit-drawer.input.label")}
            placeholder={t("favourites.edit-drawer.input.placeholder")}
            sx={{ mb: 5 }}
          />
          <Button
            startIcon={editFolder.isLoading && <CircularProgress size={20} />}
            type={"submit"}
            fullWidth
            color={"green"}>
            {t("favourites.edit-drawer.button")}
          </Button>
        </form>
      </Container>
    </SwipeableEdgeDrawer>
  );
};
